import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import './style.scss';

const claimDetailPageSkeleton = () => {
  return (
    <div className="pt-4 ">
      <Skeleton variant="text" width={250} height={60} />
      <div className="row  d-flex justify-content-around mt-1">
        <div className="col-4">
          <div  className={'col-12'}>
          <Skeleton variant="rect" height={200} />

          </div>
        </div>
        <div className="col-8 ">
          <Skeleton className={''} variant="rect" height={400} />
        </div>
       
      </div>
    </div>
  );
};
export default claimDetailPageSkeleton;
